














































import {
  Component,
  Vue
} from "vue-property-decorator";
import { userData } from '@/types'
import { Getter } from 'vuex-class';

@Component
export default class Register extends Vue {
  public firstname: string = '';
  public lastname: string = '';
  public username: string = '';
  public password: string = '';
  public confirmPassword: string = '';
  public agreement: boolean = false;
  @Getter public isError: boolean;
  @Getter public isSuccess: boolean;

  register(): void {
    const isIncorrectFilled: boolean = !this.agreement || this.password !== this.confirmPassword || !this.password || !this.confirmPassword
    if(isIncorrectFilled) {
      this.$store.commit('showErrorAlert', "Password doesn't match or aggrement didn't checked")
      setTimeout(() => {
        this.$store.commit('hideErrorAlert')
      }, 2000);
      return;
    }
    const data: userData = {
      firstname: this.firstname,
      lastname: this.lastname,
      username: this.username,
      password: this.password,
      funds: 0,
      isPremium: false,
    }
    this.$store.dispatch('register', data);
  }
}
